var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-hero-section"},[_c('div',{staticClass:"hero-content"},[_c('div',{staticClass:"hero-text"},[_c('h1',{staticClass:"hero-title"},[_c('span',{staticClass:"subtitle"},[_vm._v("Discover the World's Currencies,")]),_c('span',{staticClass:"golden-text"},[_vm._v("Unveil Global Opportunities")])])])])])
}]

export { render, staticRenderFns }